import React from 'react'
import { Box } from '../../UI';
import { Typography , Button } from '@material-ui/core';
import CurrencyField from '../../UI/CurrencyField';

export default function LoisHeader({ id }) {
    return (
        <Box display='flex'>
            <Box display='flex' flexDirection='column' mr='1rem'>
                <Typography variant='h5'><strong>{id}</strong></Typography>
                <Typography variant='body1' color='textSecondary'>Date started: 10/05/2020</Typography>
                <Typography variant='body1' color='textSecondary'>Date ending: 22/05/2020</Typography>
            </Box>
            <Box flexGrow={1} />
            <Box display='flex'>
                <Box mr='1rem'>
                    <Box display='flex' justifyContent='space-between' mb='0.5rem' flexGrow={1}>
                        <CurrencyField style={{width: '30%'}} label='Minimum price' helperText=''/>
                        <CurrencyField style={{width: '30%'}} label='LoI charge' helperText=''/>
                        <CurrencyField style={{width: '30%'}} label='LoI charge pot' helperText=''/>
                    </Box>
                    <Typography variant='body1' color='textSecondary'>23 indications to bid at lower price levels</Typography>
                </Box>
                <Box>
                    <Button variant='contained' color='primary'>Update</Button>
                </Box>
            </Box>
        </Box>
    )
}
